import './styles.scss'
import React from 'react'

export default class Index extends React.Component {
  componentDidMount() {
    const { botName, buttonSize, requestAccess, userPic, handleAuth } = this.props

    window.TelegramLoginWidget = { onAuth: (user) => handleAuth(user.id, 'telegram') }

    const script = document.createElement('script')
    script.src = 'https://telegram.org/js/telegram-widget.js?5'
    script.setAttribute('data-telegram-login', botName)
    script.setAttribute('data-size', buttonSize || 'large')
    // script.setAttribute('data-radius', cornerRadius || 3);
    script.setAttribute('data-request-access', requestAccess)
    script.setAttribute('data-userpic', userPic || false)
    script.setAttribute('data-onauth', 'TelegramLoginWidget.onAuth(user)')
    script.setAttribute('data-request-access', 'write')
    script.async = true
    this.instance.appendChild(script)
  }

  render() {
    return (
      <div
        className='telegram-login-button'
        ref={(component) => {
          this.instance = component
        }}
      >
        {this.props.children}
      </div>
    )
  }
}
